export const alphaNumericSpecial = (value) => {
  let char = String.fromCharCode(value.keyCode);
  if (/^[a-zA-Z0-9.-\s]+$/.test(char) || value.keyCode === 13) return true;
  else value.preventDefault();
};
